export const API_KEY = 'API_KEY';
export const API_KEY_COUNT = 'API_KEY_COUNT';
export const SELECTED_KEY = 'SELECTED_KEY';
export const APP_KEY_BUSY = 'APP_KEY_BUSY';
